import React from "react";
import _ from 'lodash'
import Empty from '../../../../assets/images/OCH/empty.png'

const MultipleCardView =(props) => {
  const roomData = _.get(props, "roomData");
  const deckCard = _.get(roomData, "game_state.draw_deck");
  return(
  <>
  {!_.isEmpty(deckCard) &&
  <div className="multipleCardsWrapper">
    {deckCard && deckCard.length >0 && deckCard.slice(0, 6).map((item)=>{
      return(
        <img src={props.param.cardback_img} />
      )
    })}
  </div>
  }

  {_.isEmpty(deckCard) &&
  <div className="empty-card-box" style={{backgroundImage:`url(${Empty})`}}>Empty</div>
}
  </>
)
}

export default (MultipleCardView)